import { getMenuIsLoaded } from 'selectors/menu-metadata/getMenuIsLoaded'

import menuFetchData from './fetchData'

export const loadMenuServiceDataIfDeepLinked =
  (isSignUpPage, addRecipe) => async (dispatch, getState) => {
    const menuIsLoaded = getMenuIsLoaded(getState())

    if (!menuIsLoaded) {
      await dispatch(menuFetchData({ query: {}, params: {} }, false, true, { addRecipe }))
    }
  }
